import { z } from "zod";

export const formSchema = z.object({
    connectionSequenceSteps: z.string(),
});

export type ModifyOutgoingPostbackMethodsFormData = z.infer<typeof formSchema>;
